import aboutJson from './about.json';

const About = {
  ...aboutJson,
  version: aboutJson.webVersion,
  build: aboutJson.webBuild
};

export default About;
